import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

// Location//
import { useLocation } from "react-router-dom";

function LabelOptions(props) {
  const [labels, setLabels] = useState({
    name: "",
    options: "",
  });

  const [options, setOptions] = useState([]);

  console.log("OPTIONS -----------   : ", options);

  const [isShown, setIsShown] = useState(false);

  const [type, setType] = useState();

  const location = useLocation();
  const pathArray = location.pathname.split("/");
  const campaignId = pathArray.pop();

  ////////////////   EDIT LABEL DATA /////////////////

  useEffect(() => {
    if (props.editBtn) {
      if (campaignId == "0") {
        if (props.labelData.type === "Multiple Options") {
          setIsShown(true);
          setLabels({
            question: props.labelData.name,
            options: props.labelData.options,
          });

          setOptions(props.labelData.options);
        } else {
          setIsShown(false);
          setLabels({ question: props.labelData.question_name });
        }
      } else {
        // setOptions(props.)
        if (props.labelData.options === undefined) {
          setIsShown(false);
          setLabels({ question: props.labelData.question_name });
        } else {
          setIsShown(true);
          const label_options = props.labelData.options;
          if (typeof label_options === "object") {
            setOptions(label_options);
          }
          if (typeof label_options === "string") {
            setOptions(label_options.split(","));
          }
          // setOptions(label_options);
          setLabels({
            question: props.labelData.name,
            options: props.labelData.options,
          });
        }
      }
      setType(props.labelData.type);
    }
  }, [props.labelData]);

  ////////////////////   SHOWING MULTIPLE OPTION  ///////////////////

  useEffect(() => {
    if (
      type === "Multiple Options" ||
      props.showMultipleOPtions === "Multiple Options"
    ) {
      setIsShown(true);
    } else {
      setIsShown(false);
    }

    if (props.showMultipleOPtions === "Question") {
      setIsShown(false);
    }
  }, [props.showMultipleOPtions]);

  ////////////////////   END SHOWING MULTIPLE OPTION  ///////////////////

  const handleChange = (e) => {
    const value = e.target.value;
    setLabels({
      ...labels,
      [e.target.name]: value,
    });
  };

  const AddOptions = () => {
    console.log(typeof labels.options, "LABLE OPTIONS   : ", labels.options);
    if (typeof labels.options === "string") {
      // If labels.options is a string, split it by comma
      const optionsArray = labels.options.split(",");
      setOptions((oldArray) => [...oldArray, ...optionsArray]);
    } else {
      console.error("Invalid type for labels.options:", typeof labels.options);
    }
    // setOptions((oldArray) => [...oldArray, multipleOptions]);
  };

  /////////////// SAVE LABEL DATA //////////////

  const saveLabelData = () => {
    if (type === "Multiple Options") {
      {
        labels.question === undefined || options === ""
          ? Swal.fire({
              title: "Warning !",
              text: "Please Fill ALL Fields",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
            })
          : props.setData((oldArray) => ({
              ...oldArray,
              labels: [
                ...oldArray.labels,
                {
                  name: labels.question,
                  options: options,
                  type: "Multiple Options",
                },
              ],
            }));
      }
    } else {
      {
        labels.question === undefined
          ? Swal.fire({
              title: "Warning !",
              text: "Please Fill ALL Fields",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
            })
          : props.setData((oldArray) => ({
              ...oldArray,
              questions: [
                ...oldArray.questions,
                { question_name: labels.question, type: "Question" },
              ],
            }));
      }
    }
    setLabels({});
    setOptions([]);
    setIsShown(false);
    setType("Question");
  };

  ////////  EDIT LABEL DATA /////////
  const EditLabel = () => {
    props.setData((prevState) => ({
      ...prevState,
      labels: prevState.labels.map((item, index) => {
        if (item !== props.labelData) {
          return item;
        }
        // Return a new object with updated properties
        return {
          name: labels.question,
          options: options,
          type: "Multiple Options",
        };
      }),
    }));

    props.setData((prevState) => ({
      ...prevState,
      questions: prevState.questions.map((item, index) => {
        if (item !== props.labelData) {
          return item;
        }
        // Return a new object with updated properties
        return { question_name: labels.question, type: "Question" };
      }),
    }));

    setLabels("");
    setOptions([]);
    setIsShown(false);
    props.setShowEdit(false);
  };

  if (!props.visible) return null;

  const ShowMultipleOPtions = (e) => {
    const Type = e.target.value;
    console.log(Type, "=========TYPE=======");
    setType(Type);
    if (Type === "Multiple Options") {
      setIsShown(true);
    } else {
      setIsShown(false);
    }
  };

  const deleteOption = (obj) => {
    setOptions((current) => current.filter((item) => item !== obj));
  };

  return (
    <div className="rounded-md fixed inset-0 bg-black bg-opacity-10 flex justify-center items-center">
      <div className="bg-white rounded-lg w-[40rem] p-5">
        <div className="mt-6">
          <h1 className="text-gray-400 font-bold">Feedback Question</h1>
          <input
            type="text"
            id="Question"
            name="question"
            value={labels.question || ""}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-10 p-2.5   "
            maxLength={80}
            required
          />
          <h1 className="text-gray-400 font-bold mt-8">Choose Type</h1>
          <select
            value={type}
            onChange={ShowMultipleOPtions}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-10 p-2.5   "
          >
            <option value="Question">Question</option>
            <option value="Multiple Options">Multiple Options</option>
          </select>
        </div>
        {isShown && (
          <div>
            <h1 className="text-gray-400 font-bold mt-6">Multiple options</h1>
            <input
              type="text"
              id="Answer"
              name="options"
              value={labels.options || ""}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full h-10 p-2.5   "
              required
            />
            <button
              className="flex bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full mt-4"
              onClick={AddOptions}
            >
              Add
            </button>
            <div
              className="flex flex-wrap max-w-2xl border border-gray-300 p-2 rounded-lg h-28 overflow-y-auto mt-2"
              id="multipleOptions"
            >
              {options.map((obj, index) => (
                <div
                  className="inline-flex hover:bg-gray-400 mt-5 mr-3 h-8"
                  key={index}
                >
                  <button className="bg-gray-100  text-gray-600 font-bold  px-2 rounded-l">
                    {obj}
                  </button>
                  <button
                    className="bg-gray-100  text-gray-600 font-bold  px-2 rounded-r"
                    onClick={(e) => deleteOption(obj, index)}
                  >
                    <svg
                      width="10"
                      height="11"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.4675 8.85192L1.5 12.774V11.5974C1.5 11.4011 1.42098 11.2129 1.28033 11.0741C1.13968 10.9353 0.948912 10.8574 0.75 10.8574C0.551088 10.8574 0.360322 10.9353 0.21967 11.0741C0.0790176 11.2129 0 11.4011 0 11.5974V14.5575C0.00118499 14.6542 0.0215692 14.7497 0.0599999 14.8387C0.136106 15.0195 0.281738 15.1632 0.465 15.2383C0.555167 15.2762 0.651992 15.2963 0.75 15.2975H3.75C3.94891 15.2975 4.13968 15.2195 4.28033 15.0808C4.42098 14.942 4.5 14.7538 4.5 14.5575C4.5 14.3612 4.42098 14.173 4.28033 14.0342C4.13968 13.8954 3.94891 13.8175 3.75 13.8175H2.5575L6.5325 9.90275C6.67373 9.7634 6.75307 9.57441 6.75307 9.37734C6.75307 9.18027 6.67373 8.99127 6.5325 8.85192C6.39127 8.71257 6.19973 8.63429 6 8.63429C5.80027 8.63429 5.60873 8.71257 5.4675 8.85192V8.85192ZM2.5575 1.97711H3.75C3.94891 1.97711 4.13968 1.89915 4.28033 1.76037C4.42098 1.62159 4.5 1.43336 4.5 1.23709C4.5 1.04083 4.42098 0.852599 4.28033 0.713818C4.13968 0.575037 3.94891 0.49707 3.75 0.49707H0.75C0.651992 0.49824 0.555167 0.518353 0.465 0.556272C0.281738 0.631366 0.136106 0.77506 0.0599999 0.955884C0.0215692 1.04485 0.00118499 1.14039 0 1.23709V4.19718C0 4.39345 0.0790176 4.58167 0.21967 4.72046C0.360322 4.85924 0.551088 4.9372 0.75 4.9372C0.948912 4.9372 1.13968 4.85924 1.28033 4.72046C1.42098 4.58167 1.5 4.39345 1.5 4.19718V3.02055L5.4675 6.94266C5.53722 7.01202 5.62017 7.06708 5.71157 7.10465C5.80296 7.14222 5.90099 7.16156 6 7.16156C6.09901 7.16156 6.19704 7.14222 6.28843 7.10465C6.37983 7.06708 6.46278 7.01202 6.5325 6.94266C6.6028 6.87387 6.65859 6.79202 6.69667 6.70184C6.73474 6.61166 6.75435 6.51494 6.75435 6.41725C6.75435 6.31956 6.73474 6.22283 6.69667 6.13265C6.65859 6.04247 6.6028 5.96063 6.5325 5.89183L2.5575 1.97711ZM14.25 10.8574C14.0511 10.8574 13.8603 10.9353 13.7197 11.0741C13.579 11.2129 13.5 11.4011 13.5 11.5974V12.774L9.5325 8.85192C9.39127 8.71257 9.19973 8.63429 9 8.63429C8.80027 8.63429 8.60873 8.71257 8.4675 8.85192C8.32627 8.99127 8.24693 9.18027 8.24693 9.37734C8.24693 9.57441 8.32627 9.7634 8.4675 9.90275L12.4425 13.8175H11.25C11.0511 13.8175 10.8603 13.8954 10.7197 14.0342C10.579 14.173 10.5 14.3612 10.5 14.5575C10.5 14.7538 10.579 14.942 10.7197 15.0808C10.8603 15.2195 11.0511 15.2975 11.25 15.2975H14.25C14.348 15.2963 14.4448 15.2762 14.535 15.2383C14.7183 15.1632 14.8639 15.0195 14.94 14.8387C14.9784 14.7497 14.9988 14.6542 15 14.5575V11.5974C15 11.4011 14.921 11.2129 14.7803 11.0741C14.6397 10.9353 14.4489 10.8574 14.25 10.8574ZM14.94 0.955884C14.8639 0.77506 14.7183 0.631366 14.535 0.556272C14.4448 0.518353 14.348 0.49824 14.25 0.49707H11.25C11.0511 0.49707 10.8603 0.575037 10.7197 0.713818C10.579 0.852599 10.5 1.04083 10.5 1.23709C10.5 1.43336 10.579 1.62159 10.7197 1.76037C10.8603 1.89915 11.0511 1.97711 11.25 1.97711H12.4425L8.4675 5.89183C8.3972 5.96063 8.34141 6.04247 8.30333 6.13265C8.26526 6.22283 8.24565 6.31956 8.24565 6.41725C8.24565 6.51494 8.26526 6.61166 8.30333 6.70184C8.34141 6.79202 8.3972 6.87387 8.4675 6.94266C8.53722 7.01202 8.62017 7.06708 8.71157 7.10465C8.80296 7.14222 8.90099 7.16156 9 7.16156C9.09901 7.16156 9.19704 7.14222 9.28843 7.10465C9.37983 7.06708 9.46278 7.01202 9.5325 6.94266L13.5 3.02055V4.19718C13.5 4.39345 13.579 4.58167 13.7197 4.72046C13.8603 4.85924 14.0511 4.9372 14.25 4.9372C14.4489 4.9372 14.6397 4.85924 14.7803 4.72046C14.921 4.58167 15 4.39345 15 4.19718V1.23709C14.9988 1.14039 14.9784 1.04485 14.94 0.955884V0.955884Z"
                        fill="#7B8897"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="mt-4 mb-4">
          <button
            className="font-bold text-lg rounded-full w-36 h-12"
            onClick={() => {
              props.close();
              props.setShowEdit(false);
            }}
          >
            Cancel
          </button>
          {!props.editBtn && (
            <button
              className="font-bold text-lg rounded-full w-36 h-12"
              style={{
                backgroundImage:
                  "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
                color: "white",
              }}
              onClick={saveLabelData}
            >
              Save
            </button>
          )}
          {props.editBtn && (
            <button
              className="font-bold text-lg rounded-full w-36 h-12"
              style={{
                backgroundImage:
                  "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
                color: "white",
              }}
              onClick={EditLabel}
            >
              Edit
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default LabelOptions;
